import { css, Interpolation, Theme } from '@emotion/react';

export const global: Interpolation<Theme> = ({
    body,
    headings,
    versionSpecificGlobalStyles,
}) => css`
    *,
    *:after,
    *:before {
        box-sizing: border-box;
    }

    body {
        background-color: ${body.backgroundColor};
        color: ${body.color};
        font-family: ${body.fontFamily};
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    p,
    a {
        color: inherit;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: ${headings.fontFamily};
        line-height: 1.2;
        margin: 0 0 1em;
    }

    a {
        color: inherit;
    }

    p {
        margin: 0 0 1em;
        line-height: 1.5;
    }

    a,
    button,
    [type='button'],
    [type='reset'],
    [type='submit'] {
        &:hover,
        &:focus {
            outline: none;
        }
    }

    a,
    input,
    button,
    form:-webkit-autofill,
    form:-webkit-autofill:hover,
    form:-webkit-autofill:focus {
        border: 0;
        background: transparent;
        box-shadow: none;
        border-radius: 0;
        outline: none;
    }

    /**
    * You can pass additional global styles to specific project version
    * via configs/theme file.
    */
    ${versionSpecificGlobalStyles}
`;
